import { useEffect, useRef } from 'react';

import { BringgInput, FormItem } from '@bringg/react-components';
import { TypographyColor, TypographyHelper } from '@bringg-frontend/ui';

import styles from './zipcode-filter.module.scss';

interface Props {
	name: string;
	placeholder: string;
	hint: string;
	onChange: () => void;
}

export const ZipcodeFilter = ({ name, placeholder, hint, onChange }: Props) => {
	const containerRef = useRef<HTMLDivElement>(null);

	// FilterBar2 keeps a custom filter mounted between opens and does not tell it when its popover shows
	useEffect(() => {
		const container = containerRef.current;
		const observer = new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting) {
				container.querySelector('input')?.focus();
			}
		});
		observer.observe(container);

		return () => observer.disconnect();
	}, []);

	return (
		<div ref={containerRef}>
			<FormItem name={name} noStyle>
				<BringgInput
					allowClear
					placeholder={placeholder}
					data-test-id="service-area-zipcode-filter-input"
					onChange={onChange}
				/>
			</FormItem>
			<div className={styles.hint}>
				<TypographyHelper color={TypographyColor.Subtle}>{hint}</TypographyHelper>
			</div>
		</div>
	);
};
